import { render, staticRenderFns } from "./login-dialog.vue?vue&type=template&id=0f855c14&scoped=true"
import script from "./login-dialog.vue?vue&type=script&lang=js"
export * from "./login-dialog.vue?vue&type=script&lang=js"
import style0 from "./login-dialog.vue?vue&type=style&index=0&id=0f855c14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f855c14",
  null
  
)

export default component.exports